export const styles = {
  form: 'tw-space-y-6',
  grid1: 'tw-grid tw-grid-cols-1 tw-gap-4',
  grid2: 'tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4',
  fullWidth: 'md:tw-col-span-2',
  footer: 'tw-flex tw-justify-end tw-gap-2 tw-pt-4',
};
